import React, { useState, useEffect } from "react";
import { ProposalList } from "./ProposalList.jsx";

export function LatestProposalsWidget({configuration}) {
    const [proposalset, setProposalset] = useState({proposal_set:[], answeredProposals: []});
    const [proposals, setProposals] = useState([]);
    const [answeredProposals, setAnsweredProposals] = useState([]);

    useEffect(() => {
      getProposalSet();
    }, []);

    const headers = {
        "Accept-Language": window.location.pathname.split("/")[1],
    }

    const getProposalSet = async () => {
        fetch(`/api/v1/proposals/${configuration.proposalsetId}/get_latest_proposals/?max_proposals=${configuration.max_proposals}`, {headers: headers})
            .then(response => response.json())
            .then(data => {
                setProposalset(data);
                setProposals(data.proposal_set);
                setAnsweredProposals(data.answer_set);
            });
    };

    let out;
    if (proposals.length > 0) {
        out = (
            <div id="latest-proposals-widget-container" className="proposalsWidget-lastProposal">
                <h2 className="proposalsWidget-lastProposal_title">{configuration.translations.lastProposals}</h2>
                <div id="latest-proposals-widget">
                    <div className="latest-proposals-widget">
                        <ProposalList
                            proposals={proposals}
                            answeredProposals={answeredProposals}
                            setAnsweredProposals={setAnsweredProposals}
                            configuration={configuration}
                            />
                    </div>
                </div>
            </div>
        )
    } else {
        out = "";
    }

    return out;
}
